import React from 'react';
import ChevronDown from 'src/assets/icons/ChevronDown';

export const ExpandMore = () => <ChevronDown size={14} />;
